// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KdKUoAwY4v0Y64q8Ue9X{width:100%;padding-top:8px}.Gz3Rb_lx3hgP_KbHWwkS{margin-left:6px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `KdKUoAwY4v0Y64q8Ue9X`,
	"addRightIcon": `Gz3Rb_lx3hgP_KbHWwkS`
};
export default ___CSS_LOADER_EXPORT___;
